module.exports = __webpack_public_path__ + "static/media/etat-biberon-blue.e32099d2.svg";